module.exports = __webpack_public_path__ + "static/media/krowd_logo_login.a0f066b3.png";